import { CalendarView } from '../../features/calendar/CalendarView'

/** S6 Calendar (case team). */
export function CalendarPage() {
  return <CalendarView area="workspace" />
}
